import Link from 'components/Link';
import Checkboxes from 'components/Formik/Checkboxes';

function MultiPurposeOptIn({ initialValues, formik, language }) {
    initialValues.multipurposeOptIn = [];
    const condition =
        formik.values.Country === 'United States' &&
        ['CO', 'CT', 'VA'].includes(formik.values.State) &&
        language === 'default';
    return (
        condition && (
            <>
                <p className="small">
                    I agree that the information I've provided above, some of
                    which may be considered to reveal sensitive personal
                    information such as any information about cardiovascular or
                    other health care conditions, may be used by Edwards (and
                    its contracted third parties) to enroll me into this
                    program, which will provide me with information and
                    opportunities (“Program”). Edwards requires your sensitive
                    personal information to determine your eligibility for the
                    Program and associated benefits and subsequent
                    communications. For more information about how we will use
                    and disclose your information please review our{' '}
                    <Link href="/legal/privacy-policy">Privacy Policy</Link>.
                </p>
                <Checkboxes
                    parse={true}
                    options={[
                        {
                            label: "<p class='small'>By clicking this box, I further agree that the information I've provided above, including any sensitive information, may be used to provide me with information, offers, and marketing materials for Cardiovascular and related diseases and associated treatments, products and services, in addition to those in the Program. Edwards will not sell or transfer my name or contact information to any third party for its own marketing use. I understand that I may opt-out from such communications at any time by clicking the unsubscribe link in any email from Edwards and opt-out of the program by calling <span style='display:inline-block'>(888) 570-4014</span>.</p>",
                            value: true,
                        },
                    ]}
                    name="multipurposeOptIn"
                />
            </>
        )
    );
}
export default MultiPurposeOptIn;
